<template>
  <a-carousel arrows :after-change="onChange" autoplay>
    <div style="width: 100%;height: 100%;" v-for="(item,index) in bannerData">
		<img  style="width: 100%;height: 500px;" :src="item">
	</div>
   <div
         slot="prevArrow"
         slot-scope="props"
         class="custom-slick-arrows"
         style="left: 64px;zIndex: 1"
       >
        <img src="../../assets/images/letbut.png">
       </div>
       <div slot="nextArrow" slot-scope="props" class="custom-slick-arrows" style="right: 64px">
         <img src="../../assets/images/letbut2.png">
       </div>

  </a-carousel>
</template>
<script>
	import {logoBanner} from '../../api/index.js'
export default {
	data(){
		return{
			logoBanner,
			bannerData:[]
		}
	},
	 created() {
		this.getLogoBanner()
		
	},
  methods: {
    onChange(a, b, c) {
      console.log(a, b, c);
    },
	async getLogoBanner(){
		const data = await logoBanner()
		this.bannerData = data.data.data.banner
	}
  },
};
</script>
<style scoped>
/* For demo */
/* .ant-carousel >>> .slick-slide {
  text-align: center;
  height: 100%;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
} */

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
</style>
<style scoped>
/* For demo */
.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.custom-slick-arrows:hover{
	opacity: 0.8;
}
</style>